/*
*###############################################################################
*Module Name                   : PendingApprovels.js                           #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Wednesday, March 30th 2022, 7:24:18 am        #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/


import React, { Component } from 'react';
import { Col, Row, Button, Card, CardBody, CardTitle, Modal, ModalFooter } from 'reactstrap';
import Approvel from "../Approvel"


const PendingApprovels = ({
    isOpen,
    toggle,
    SubTitle,
    Details,
    txn,
    DocNo,
    DocDate,
    LocCode,
    LocName,
    User,
    NetValue,
    ApprovelDetails,
    getData
}) => {
    return (
        <div>
            <Modal
                size="xl"
                isOpen={isOpen}
                toggle={toggle}
                style={{ maxWidth: '90%', width: '90%', height: '90%' }}
            /*className="modal-fullscreen"*/
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {"Pending Approvels"}
                    </h5>
                    <button
                        onClick={toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {Details}
                                    </p>
                                    <React.Fragment>
                                        <Row>
                                            <Col sm={12} md={12} className="mb-12-sm">
                                                <Approvel
                                                    txn={txn}
                                                    DocNo={DocNo}
                                                    DocDate={DocDate}
                                                    LocCode={LocCode}
                                                    LocName={LocName}
                                                    User={User}
                                                    NetValue={NetValue}
                                                    ApprovelDetails={ApprovelDetails}
                                                    getData={getData}
                                                />
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default PendingApprovels;